import type { ComponentProps } from 'react';

export const PlusIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 6V12M12 18V12M12 12H6M12 12H18" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
};
